export default function SkeletonMetricCard() {
  return (
    <div className="bg-white dark:bg-background-100 rounded-xl border border-background-200 dark:border-background-300 p-5 animate-pulse">
      <div className="flex items-start justify-between">
        <div className="space-y-3 flex-1">
          <div className="h-3 w-16 bg-background-200 dark:bg-background-300 rounded-md" />
          <div className="h-7 w-20 bg-background-200 dark:bg-background-300 rounded-lg" />
          <div className="h-3 w-28 bg-background-200 dark:bg-background-300 rounded-md" />
        </div>
        <div className="w-10 h-10 rounded-lg bg-background-200 dark:bg-background-300" />
      </div>
    </div>
  );
}